// Rho's Unique Device Identifier, as the product prints it on its About page.
// Mirrors rho-product services/frontend/src/lib/about.ts and the DMS Lambda
// copy in lambda/GitOpsOrchestrator/lib/udi.js. Keep all three in step.
const GTIN_USA = '06287194090220';
const GTIN_CANADA = '06287194090084';

export function gtinFor(jurisdiction) {
  return String(jurisdiction || '').trim().toUpperCase() === 'USA' ? GTIN_USA : GTIN_CANADA;
}

export function udiFor(jurisdiction, targetRevision) {
  const version = String(targetRevision || '').trim().replace(/^v/i, '');
  if (!version) return null;
  return `(01)${gtinFor(jurisdiction)} (8012)v${version}`;
}
